var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCouplerReducer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: 345.18755539924535,
    y: 345.18755539924535,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    stroke: "currentColor",
    fill: "#FFFFFF",
    height: 13.8,
    width: 73.9,
    y: 33,
    x: 3.2
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "currentColor",
    height: 3,
    width: 60,
    y: 38.4,
    x: 10.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCouplerReducer);
export default __webpack_public_path__ + "static/media/couplerReducer.c5b69e960bfb82f9c6f4ea5ba79a0bab.svg";
export { ForwardRef as ReactComponent };